var ToggleComponent = (function () {
    function ToggleComponent() {
    }
    ToggleComponent.prototype.ngOnInit = function () {
    };
    return ToggleComponent;
}());
export { ToggleComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/toggle/toggle.component.ts.pre-build-optimizer.js